import { Box, Typography } from "@mui/material";
import { Outlet, useParams } from "react-router-dom";
import EditCompanyHeader from "./EditCompanyHeader";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";


import { loadCompanyDraft } from "../../../features/editCompany/editCompanySlice";
import { flattenForEdit } from "../../../features/editCompany/flattenForEdit";

export default function EditCompany() {
  const dispatch = useDispatch();
  const { companyId } = useParams();

  // 🔑 READ from company store
  /* const company = useSelector(
    (state) => state.company.byId[companyId]
  ); */
  // This will now find the mock data in state.company.byId["1"]
  const company = useSelector((state) => {
  console.log("Current Store:", state.company.byId);
  console.log("Looking for ID:", companyId);
  return state.company.byId[companyId];
});

  useEffect(() => {
    if (company) {
      // This fills the 'editCompany' slice with the mock data
      dispatch(loadCompanyDraft(flattenForEdit(company)));
    }
  }, [company, dispatch]);

  
  // If ID doesn't match mock, show a helper message
  if (!company) {
    return (
      <Box sx={{ p: 4, textAlign: 'center' }}>
        <Typography variant="h6">Company ID {companyId} not found in Mock Data.</Typography>
        <Typography>Try navigating to /company/1/edit</Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ flex: 1 }}>
      <EditCompanyHeader />
      <Outlet />
    </Box>
  );
}
